import { useTitle } from "@vueuse/core";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";

export const useDynamicTitle = () => {
    const { t } = useI18n();
    const route = useRoute();

    const title = computed(() => {
        return `${import.meta.env.VITE_APP_TITLE} ${t(route.meta.title)}`;
    });

    useTitle(title);
};
